<template>
  <div class="site-nav clearfix">
    <div class="container">
      <!-- 主菜单栏 -->
      <ul class="site-nav-menu">
          <li><a :href="configUrl.home" class="logo" target="_blank">
              <img src="/static/images/logo.png"/>
          </a></li>
          <li><a :href="configUrl.home" target="_blank">首页</a></li>
          <li>
              <a :href="configUrl.course" target="_blank" class="cursor">我的课程</a>
              <!-- 全部老师下拉窗 -->
              <!-- end 全部老师下拉窗 -->
          </li>
          <li><a :href="configUrl.community" target="_blank">步知家园</a></li>
          <li><a :href="configUrl.download" target="_blank">下载APP</a></li>
      </ul>
      <!-- end 主菜单栏 -->
      <!-- 菜单栏右侧 登录注册 -->
      <div class="site-nav-login" v-show="isLogin">
          <span class="login" @click.stop="loginTo">登录</span>
          <span class="register" >注册</span>
      </div>
      <!-- end 菜单栏右侧 登录注册 -->
      <!-- 菜单栏右侧 已登录 -->
      <div class="site-nav-user" :class="{active:isShowMenu}" v-show="!isLogin" @mouseenter="isShowMenu =!isShowMenu" @mouseleave="isShowMenu =!isShowMenu">
          <div class="avatar">
              <img :src="avatar">
              <!-- <span class="badge">10</span> -->
          </div>
          <div class="userinfo"><span class="name">{{nikename}}</span></div>
          <ul class="menu" v-show="isShowMenu">
              <li><a :href="`${configUrl.message}/msg`" target="_blank"><i class="iconfont icon-xinxi"></i>消息系统</a></li>
              <!-- <li><a href="http://ask.buzhi.com/user/thread" target="_blank"><i class="iconfont icon-user"></i>个人中心<span></span></a></li> -->
              <li><a :href="configUrl.setting" target="_blank"><i class="iconfont icon-shezhi"></i>个人设置</a></li>
              <li @click="loginOut"><i class="iconfont icon-logout"></i>退出登录</li>
          </ul>
      </div>
      <!-- end 菜单栏右侧 已登录 -->
    </div>
</div>

</template>
<script>
    import {
        mapGetters
    } from 'vuex'
    import {
        loginRef,
        baseUrl,
        STATUS_OK
    } from 'src/assets/api/config'
    import {
        uloginOut
    } from "src/assets/api/list"
    export default {
        data() {
            return {
                isShow: false, //是否显示老师下拉
                isShowMenu: false, //已登录下拉菜单
                configUrl: {}
            }
        },
        computed: {
            ...mapGetters(['uid', 'phone','nikename', 'avatar']),
            // 获取是否需要登录
            isLogin() {
                if (this.uid) {
                    return false
                } else {
                    return true
                }
            }
        },
        mounted () {
            window.sessionStorage.setItem('user_id', this.uid)
            window.sessionStorage.setItem('user_mobile',this.phone)
            if (window.location.href.indexOf('tiku.beta.buzhi.com') != -1 || window.location.href.indexOf('127') != -1) { // 测试
              this.configUrl = {
                home: 'http://ad.buzhi.com/gbuzhi/dist',
                course: 'http://ad.buzhi.com/gbuzhi/dist/#/myCourse',
                community: 'http://ask.gk.buzhi.com',
                download: 'http://ad.buzhi.com/gbuzhi/dist/#/download',
                message: 'http://ad.buzhi.com/gbuzhi/dist/#/myMessage',
                setting: 'http://ad.buzhi.com/gbuzhi/dist/#/myInfoSetting'
              }
            } else {
               this.configUrl = {
                home: 'http://g.buzhi.com',
                course: 'http://g.buzhi.com/#/myCourse',
                community: 'http://ask.buzhi.com',
                download: 'http://g.buzhi.com/#/download',
                message: 'http://g.buzhi.com/#/myMessage',
                setting: 'http://g.buzhi.com/#/myInfoSetting'
              }
            }
        },
        methods: {
            // 点击登录
            loginTo(){
                window.location.href = loginRef + baseUrl
            },
            //  退出登录
            loginOut() {
                uloginOut().then((res) => {
                  debugger
                    if (res.status === STATUS_OK) {
                        window.location.href = res.data
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
  $cl-bd-grey:#ebebeb;
  $cl-666:#5b6978;
  $cl-white:#fff;
  $blueColor: #218df1;
  $whiteColor: #fff;
  $blueHoverColor: #1e6eb9;  // 蓝色字体悬浮
  $blueHoverBgColor: rgba(33, 141, 241, .7);  // 悬停蓝色背景
    .site-nav {
        height: 74px;
        // padding-left: 70px;
        // padding-right: 30px;
        // background: #2d3e50;
        font-size: 18px;
        color: #6F7275;
        z-index: 10;
        background-color: #fff;
        box-shadow: 0 0 10px 4px rgba(207, 211, 214, .22);
        a {
            color: #6F7275;
        }
    }
    .container{
      margin: 0 auto;
      width: 1200px;
    }

    /* 主菜单栏 */

    .site-nav-menu {
        float: left;
        li {
            display: inline-block;
            padding-right: 74px;
            line-height: 74px;
            text-align: center;
            position: relative;
            &:first-child {
                padding-right: 58px;
            }
            // &:before {
            //     background: #eb5255;
            //     border-radius: 2px;
            //     bottom: 0;
            //     content: "";
            //     height: 4px;
            //     position: absolute;
            //     transition: all 0.3s ease 0s;
            //     left: 50%;
            //     width: 0;
            // }
            // &:hover::before {
            //     left: 20%;
            //     right: 20%;
            //     width: 60%;
            // }
        }
        .cursor {
            cursor: pointer;
        }
        .logo {
             position: relative;
             top: -2px;
            display: inline-block;
            vertical-align: middle;
            width: 140px;
            img {
                display: block;
                width: 100%;
                height: auto;
            }
        }
        a, span{
          transition: all .3s;
          &:hover{
            color: $blueColor;
          }
        }
    }

/*课程下拉窗*/
.nav-drop-down {
    position: fixed;
    top: 74px;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 120px;
    border-top: 1px solid $cl-bd-grey;
    border-bottom: 1px solid $cl-bd-grey;
    background-color: $cl-white;
	z-index:2;
    .drop-container {
        text-align: center;
    }
    .drop-item {
        display: inline-block;
        margin-right: 90px;
        padding-top: 10px;
        width: 140px;
        text-align: center;
        line-height: 24px;
        color: $cl-666;
        font-size: 14px;
        cursor: pointer;
        &:last-child {
            margin-right: 0;
        }
        .pic-box {
            width: 80px;
            height: 70px;
            margin: 0 auto;
            vertical-align: middle;
            display: flex;
            justify-content: center;
            align-items: center;
			img {
				width: 50px;
				height: 50px;
				vertical-align: middle;
				transition: 0.5s;
			}
        }
		.name {
            font-size: 16px;
			img{
				width:15px;
				vertical-align: middle;
			}
        }
        &:hover{
			.pic-box img {
				width: 65px;
				height: 65px;
        	}
			.name{
				color:$cl-666;
			}
		}
    }
}


    /* 登录注册 */

    .site-nav-login {
        float: right;
        margin-top: 16px;
        font-size: 16px;
        line-height: 32px;
        text-align: center;
        .login {
            text-align: center;
            line-height: 38px;
            width: 110px;
            height: 38px;
            font-size: 18px;
            border-radius: 21px;
            display: inline-block;
            color: $blueColor;
            border: 2px solid $blueColor;
            cursor: pointer;
            &:hover {
              color: $blueHoverColor;
              border-color: $blueHoverColor;
            }
        }
        .register {
            text-align: center;
            line-height: 42px;
            width: 110px;
            height: 42px;
            font-size: 18px;
            border-radius: 21px;
            display: inline-block;
            cursor: pointer;
            margin-left: 28px;
            color: $whiteColor;
            background-color: $blueColor;
            &:hover{
              background-color: $blueHoverBgColor;
            }
        }
    }

    /* 已登录 */

    .site-nav-user {
        position: relative;
        float: right;
        padding: 0;
        color: #899faa;
        font-size: 14px;
        cursor: pointer;
        // &.active {
        //     background: #4b5f74;
        // }
        .iconfont {
            font-size: 24px;
            color: #899faa;
        }
        .menu {
            top: 66px;
            padding: 0 20px;
            width: 100px;
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 6px 16px 0 rgb(175, 175, 175);
            position: absolute;
            z-index: 2;
            right: 0;
            li {
                display: block;
                position: relative;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                margin: 0;
                padding: 5px 0;
                line-height: 30px;
                font-size: 14px;
                color: #606266;
                cursor: pointer;
                outline: 0;
                border-top: 1px dashed #ddd;
                &:first-child{
                  border-top: none;
                }
                &:hover{
                  color: #66b1ff;
                  background: #fff;
                  .iconfont, a{
                    color: #66b1ff;
                  }
                }
                .iconfont,  a{
                    // font-size: 20px;
                    margin-right: 10px;
                    color: #606266;
                    transition: all .3s;
                }
                .iconfont{
                  position: relative;
                  top: 2px;
                }
            }
        }
        .avatar {
            float: left;
            position: relative;
            margin-top: 17px;
            margin-right: 12px;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            overflow: hidden;
            img {
                width: 100%;
                height: auto;
                vertical-align: top;
            }
            .badge {
                position: absolute;
                top: -8px;
                left: 20px;
                width: 30px;
                text-align: center;
                height: 16px;
                line-height: 16px;
                border: 2px solid #be4244;
                background: #eb5255;
                border-radius: 8px;
                color: #FAFAFA;
                font-size: 12px;
            }
        }
        .userinfo {
            float: left;
            padding-right: 0;
            height: 74px;
            line-height: 74px;
            position: relative;
            .name {
                display: inline-block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 14px;
                font-family: "Microsoft YaHei", "\9ED1\4F53", "\5B8B\4F53", Arial, Helvetica, sans-serif;
                width: auto;
                max-width: 56px;
                padding-right: 24px;
                color: rgb(96, 98, 102);
                background: url('./images/icon-userinfo-arrow.png') no-repeat right 52%;
                background-size: 14px auto;
            }
            .iconfont {
                position: absolute;
                right: 0;
                top: 26px;
                font-size: 22px;
                line-height: 24px;
            }
        }
    }

    /* 登录、注册弹窗 */

    .overlay-mask {
        position: fixed;
        background: rgba(0, 0, 0, 0.5);
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: 9;
    }

    .overlay-pannel {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        width: 400px;
        height: 400px;
        background: #fff;
        padding: 50px 30px;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        color: #666;
        font-size: 12px;
    }

    .overlay-success {
        width: 760px;
    }

    .overlay-hd {
        text-align: center;
        position: relative;
    }

    .overlay-close {
        position: absolute;
        right: -10px;
        top: -30px;
        font-size: 18px;
        line-height: 14px;
        color: #999;
        cursor: pointer;
        transform-origin: center;
        transform: rotateZ(0);
        transition: transform .5s;
        &:hover {
            color: #ad2f31;
            transform: rotateZ(180deg);
        }
    }

    .overlay-hd .header {
        height: 60px;
        line-height: 60px;
        font-size: 24px;
        font-weight: bold;
        color: #eb5255;
        margin-bottom: 40px;
    }

    .overlay-bd {
        text-align: center;
        .col-2 {
            width: 254px;
            margin: auto;
        }
        .title {
            font-size: 14px;
            color: #666;
            text-align: center;
            margin-bottom: 10px;
            .iconfont {
                font-size: 14px;
            }
            .strong {
                color: #449cd4;
            }
        }
        .overlay-header {
            cursor: pointer;
            &:hover {
                color: #449cd4;
            }
        }
        .overlay-tips {
            height: 24px;
            line-height: 24px;
            text-align: center;
            color: #ab2b2b;
            margin-bottom: 10px;
        }
        .input {
            width: 254px;
            height: 38px;
            line-height: 38px;
            text-indent: 10px;
            color: #999;
            font-size: 14px;
            background: #e9eff7;
            border-radius: 5px;
            border: 2px solid #d9d9d9;
        }
        .verify-code {
            width: 62%;
            float: left;
        }
        .verify-btn {
            float: right;
            width: 34%;
            height: 38px;
            line-height: 38px;
            text-align: center;
            color: #fff;
            font-size: 14px;
            border-radius: 5px;
            background: #818b96;
            cursor: pointer;
        }
        .submit {
            width: 254px;
            height: 44px;
            line-height: 44px;
            text-align: center;
            font-size: 16px;
            color: #fff;
            background-color: #eb5255;
            border: 2px solid #b23033;
            border-radius: 5px;
            &:hover {
                background-color: #b23033;
            }
        }
        .block {
            margin-bottom: 15px;
        }
        .qrcode {
            width: 170px;
            height: 170px;
            margin-bottom: 10px;
            border: 4px solid #d9d9d9;
            border-radius: 4px;
        }
        .msg {
            font-size: 12px;
        }
        .agreement {
            .iconfont {
                font-size: 12px;
                margin-right: 2px;
            }
        }
        .agreelink {
            color: #2e9ff7;
            text-decoration: underline;
            &:hover {
                color: #3584b7;
                text-decoration: none;
            }
        }
        .qq-mail {
            width: 70%;
            float: left;
        }
        .qq-label {
            font-size: 14px;
            float: right;
            width: 29%;
            height: 38px;
            line-height: 38px;
        }
        .teachlist {
            li {
                display: table-cell;
                text-align: center;
                vertical-align: middle;
                font-size: 14px;
                line-height: 24px;
                margin-right: 30px;
            }
            img {
                display: block;
                width: 224px;
                height: 224px;
                text-align: center;
                line-height: 224px;
                border: 4px solid #d9d9d9;
                border-radius: 5px;
                margin: 10px;
                &:hover {
                    border-color: #eb5255;
                }
            }
        }
    }

    .overlay-fd {
        font-size: 14px;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        &:hover {
            color: #eb5255;
        }
        .iconfont {
            font-size: 14px;
            color: #eb5255;
            margin-left: 5px;
        }
        .red {
            color: #eb5255;
        }
    }

// 动画切换
.dropDown-enter-active,
.dropDown-leave-active {
    transition: all .3s;
}

.dropDown-enter,
.dropDown-leave-active {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue